import type {
  GA4AdvancedPackageSearchLink,
  GA4CustomizeCarCheckboxClick,
  GA4CustomizeHotelCheckboxClick,
  GA4OnSearchButtonClickForSuccessfulSearchTrigger,
  GA4PackageCustomSearchPromotion,
  GA4PackageFormAdvancedSearchLink,
} from '@/ga4types'
import analytics from '@/shared-utils/analytics'

import type { PackageFormTripType, PackagesFormStateType } from './types'

export default function firePackagesFormGA4Event(
  initialState: PackagesFormStateType,
  submittedState: PackagesFormStateType,
  pageName: 'landing' | 'homepage',
) {
  analytics.fireGA4Event({
    event: 'search',
    attributes: {
      cabin_class_change: initialState.includeBasicEconomy !== submittedState.includeBasicEconomy ? 'y' : 'n',
      date_change:
        initialState.startDate !== submittedState.startDate ||
        initialState.endDate !== submittedState.endDate ||
        initialState.hotelStartDate !== submittedState.hotelStartDate ||
        initialState.hotelEndDate !== submittedState.hotelEndDate ||
        initialState.rcPickupDate !== submittedState.rcPickupDate ||
        initialState.rcDropoffDate !== submittedState.rcDropoffDate
          ? 'y'
          : 'n',
      trip_start_city_change: initialState.startLocation !== submittedState.startLocation ? 'y' : 'n',
      trip_end_city_change: initialState.endLocation !== submittedState.endLocation ? 'y' : 'n',
      quantity_change:
        initialState.travelers.adults !== submittedState.travelers.adults ||
        initialState.travelers.children !== submittedState.travelers.children ||
        initialState.travelers.rooms !== submittedState.travelers.rooms
          ? 'y'
          : 'n',
      page_name: pageName,
      product_name: 'bundle',
    },
  })
}

export function fireOnSearchButtonClickForSuccessfulSearchTrigger(
  pageName: 'landing' | 'homepage',
  packageType: PackageFormTripType,
) {
  const ga4Event: GA4OnSearchButtonClickForSuccessfulSearchTrigger = {
    event: 'internal_link',
    attributes: {
      link_item: packageType,
      page_name: pageName,
      product_name: 'bundle',
      link_name: 'search_button',
    },
  }
  analytics.fireGA4Event(ga4Event)
}

export function trackPackageSearchLinkClick(
  pageName: 'landing' | 'homepage',
  packageType: PackageFormTripType,
) {
  const ga4Event: GA4PackageFormAdvancedSearchLink = {
    event: 'select_promotion',
    attributes: {
      type: packageType,
      page_name: pageName,
      product_name: 'bundle',
      link_name: 'advanced_search',
    },
  }
  analytics.fireGA4Event(ga4Event)
}

export function fireCustomizeCarCheckboxClick(pageName: 'landing' | 'homepage') {
  const ga4Event: GA4CustomizeCarCheckboxClick = {
    event: 'internal_link',
    attributes: {
      link_name: 'customize_car',
      link_text: 'hc',
      page_name: pageName,
      product_name: 'bundle',
    },
  }
  analytics.fireGA4Event(ga4Event)
}

export function fireAdvancedPackageSearchLinkClick(pageName: 'landing' | 'homepage') {
  const ga4Event: GA4AdvancedPackageSearchLink = {
    event: 'internal_link',
    attributes: {
      link_name: 'advanced_package_search',
      page_name: pageName,
      product_name: 'bundle',
    },
  }
  analytics.fireGA4Event(ga4Event)
}

export function fireCustomizeHotelCheckboxClick(pageName: 'landing' | 'homepage', linkText: 'ha' | 'ahc') {
  const ga4Event: GA4CustomizeHotelCheckboxClick = {
    event: 'internal_link',
    attributes: {
      link_name: 'customize_hotel',
      link_text: linkText,
      page_name: pageName,
      product_name: 'bundle',
    },
  }
  analytics.fireGA4Event(ga4Event)
}

export function trackPackageSearchLinkView(
  pageName: 'landing' | 'homepage',
  packageType: PackageFormTripType,
) {
  const ga4Event: GA4PackageFormAdvancedSearchLink = {
    event: 'view_promotion',
    attributes: {
      type: packageType,
      page_name: pageName,
      product_name: 'bundle',
      link_name: 'advanced_search',
    },
  }
  analytics.fireGA4Event(ga4Event)
}

export function trackCustomPackageSearchPromotionView(pageName: 'landing' | 'homepage') {
  const ga4Event: GA4PackageCustomSearchPromotion = {
    event: 'view_promotion',
    attributes: {
      type: 'add_on',
      product_name: 'package',
      page_name: pageName,
      promotion_name: 'custom_package_search_link',
      bundle_flag: 'y',
    },
  }
  analytics.fireGA4Event(ga4Event)
}

export function trackCustomPackageSearchPromotionClick(pageName: 'landing' | 'homepage') {
  const ga4Event: GA4PackageCustomSearchPromotion = {
    event: 'select_promotion',
    attributes: {
      type: 'add_on',
      product_name: 'package',
      page_name: pageName,
      promotion_name: 'custom_package_search_link',
      bundle_flag: 'y',
    },
  }
  analytics.fireGA4Event(ga4Event)
}
